const HAIRSTYLE_PAYWALL_URL = "/hairstyle-3month-29-woman";

export const buildHairstyleUserPhotoContinueUrl = ({
  search = "",
  queuedJobId = "",
} = {}) => {
  const params = new URLSearchParams(String(search || "").replace(/^\?/, ""));
  const hasUserImage = Boolean((params.get("img") || params.get("image") || "").trim());

  params.delete("utm_ab");

  if (queuedJobId && hasUserImage) {
    params.set("facemesh_job_id", queuedJobId);
  } else {
    params.delete("facemesh_job_id");
  }

  const queryString = params.toString();
  return queryString ? `${HAIRSTYLE_PAYWALL_URL}?${queryString}` : HAIRSTYLE_PAYWALL_URL;
};
